import { render, staticRenderFns } from "./immediatelyTalk.vue?vue&type=template&id=28542a6c&scoped=true"
import script from "./immediatelyTalk.vue?vue&type=script&lang=js"
export * from "./immediatelyTalk.vue?vue&type=script&lang=js"
import style0 from "./immediatelyTalk.vue?vue&type=style&index=0&id=28542a6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28542a6c",
  null
  
)

export default component.exports